"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevenueTypeEnum = exports.MonetizableEnum = exports.SkuSourceEnum = exports.SkuLevelEnum = void 0;
var SkuLevelEnum;
(function (SkuLevelEnum) {
    SkuLevelEnum["Institution"] = "institution";
    SkuLevelEnum["Offer"] = "offer";
    SkuLevelEnum["Product"] = "product";
})(SkuLevelEnum || (exports.SkuLevelEnum = SkuLevelEnum = {}));
var SkuSourceEnum;
(function (SkuSourceEnum) {
    SkuSourceEnum["Marketplace"] = "marketplace";
    SkuSourceEnum["Plinko"] = "plinko";
    SkuSourceEnum["Treehouse"] = "treehouse";
})(SkuSourceEnum || (exports.SkuSourceEnum = SkuSourceEnum = {}));
var MonetizableEnum;
(function (MonetizableEnum) {
    MonetizableEnum["No"] = "no";
    MonetizableEnum["NoBecauseOfDetails"] = "no_because_of_details";
    MonetizableEnum["NoBecauseOfLead"] = "no_because_of_lead";
    MonetizableEnum["NoBecauseOfLeadForm"] = "no_because_of_lead_form";
    MonetizableEnum["NoBecauseOfLimit"] = "no_because_of_limit";
    MonetizableEnum["YesAssumed"] = "yes_assumed";
})(MonetizableEnum || (exports.MonetizableEnum = MonetizableEnum = {}));
var RevenueTypeEnum;
(function (RevenueTypeEnum) {
    RevenueTypeEnum["Estimated"] = "estimated";
    RevenueTypeEnum["Ingested"] = "ingested";
})(RevenueTypeEnum || (exports.RevenueTypeEnum = RevenueTypeEnum = {}));
